import Task from './Task'

const Tasks = ({tasks, onDelete, onToggle}) => {
  return (
    <>
     {tasks.map((task)=>(
     <Task key ={task.id} task={task}
     onDelete={onDelete}
     onToggle={onToggle}/>
 //we must have key or single component /looping and passing task
 ))}
    </>
  ) 
}
export default Tasks